/**
 * Asynchronously loads the component for ResultsPage
 */

import loadable from 'utils/loadable';

export const ResultsPageLoadable = loadable(() => import('./ResultsPage'));
